export enum ERROR_CODE {
  WEB3_PROVIDER_NOTFOUND = "WEB3_PROVIDER_NOTFOUND",
}
export const MAX_INT =
  "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";
export const BURN_ADDRESS = "0x0000000000000000000000000000000000000000";

export const TOTAL_SECONDS_IN_DAY = 60 * 60 * 24;
export const DATE_TIME_FORMAT = "dd MMM yyyy HH:mm:ss";
export const CLAIMED_STATUS = 1;
